import { useContext } from 'react';
import * as wasm from 'sched';
import { WorkspaceContext } from '../context/WorkspaceContext';
import { useDatabaseEntity } from './useDatabaseEntity';

export interface PersonDetails {
  id: string;
  name: string;
  avatarUrl?: string;
  teamIds: string[];
  remoteReferences: wasm.RemoteReference[];
}

export function usePerson(personId: string | undefined) {
  const { safeData } = useContext(WorkspaceContext);
  const { entity, loading, error } = useDatabaseEntity<PersonDetails>(personId, {
    entityType: 'Person',
    deps: [safeData],
    build: async (database, id) => {
      const obj = database.people()[id];
      if (!obj) return null;
      const base: PersonDetails = {
        id,
        name: obj.name(),
        avatarUrl: obj.avatar_url(),
        teamIds: [],
        remoteReferences: [],
      };
      if (!safeData) return base;
      try {
        const [teamIds, remoteReferences] = await Promise.all([
          obj.team_ids(safeData),
          obj.remote_references(),
        ]);
        return { ...base, teamIds, remoteReferences: remoteReferences || [] };
      } catch (err) {
        console.error('Error fetching person enrichment:', err);
        return base;
      }
    },
  });
  return { person: entity, loading, error };
}
